import { Row } from 'antd';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { GUTTOR_SPACE } from '../../../../../../../shared/constants/commonConstants';
import { useFindPayer } from '../../../../../../../shared/hooks/useFindPayer';
import { RootState } from '../../../../../../../store';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../../config/formControlConfig';
import FormDynamic from '../../../../../../../shared/components/crmFormElement/FormDynamic/FormDynamic';

const DynamicTreatmentDetailCard = ({ form, isLoading }: any): ReactElement | null => {
  const {
    payerList: { payer: { name, isRpaPayer } },
    admissionDetails: { claimDetails: claimDetail = {} },
  } = useSelector((state: RootState): RootState => state);
  const dynamicQuestionFields = useSelector((state: RootState): any => state.newAdmission.dynamicQuestionFields);

  let payerName = name;
  const findPayer = useFindPayer();
  if (claimDetail && !payerName) {
    const { payerId } = claimDetail;
    payerName = findPayer(payerId);
  }

  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[payerName];

  let formElementCount: any[] = [];

  if (payerConfig) {
    const payerConfigValues = Object.values(payerConfig);
    formElementCount = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'treatment' && !hidden);

  }

  const commonDetail = { isLoading, form };

  return (
    (formElementCount?.length || isRpaPayer) ?
      <Row gutter={GUTTOR_SPACE} data-testid="other-treatment-detail">
        {dynamicQuestionFields.map((input: any): any => (
          <FormDynamic detail = {{
            ...commonDetail,
            inputType: input.inputType,
            key: input.key,
            label: input.label,
            options: input.options,
            size: 12,
            required: input.isRequired,
            regex: input.validationRegex,
            rules: input.rules,
            isFormDynamic : true,
          }}
          key= {input.key}/>
        ))}
      </Row> : null
  );
};

export default withRouter(DynamicTreatmentDetailCard);
